import * as React from 'react';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { AppUser } from 'Src/views/App/App';
import { Component } from 'react';
import { Loader } from 'Src/components/Loader/Loader';
import { ClubBookingCard } from 'Src/components/ClubBookingCard/ClubBookingCard';
import { EventInvitationMessage } from 'Src/models/message';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, CARD_LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION,
  getSearchFilter,
  getSearchOrder,
  getOrder
} from 'Src/helpers/table/table';
import {
  getStudentArchiveMessages,
  getStudentArchiveMessagesCount,
  cancelRejectionOfStudentClubInvitation
} from 'Src/helpers/service/student/messagesTable';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { INVITE_TYPE } from 'Src/consts/invite';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Map } from 'Src/components/Map/Map';
import { ClubBookingDeatils } from 'Src/views/GenericView/ParentView/ClubBookings/ClubBookingDetails/ClubBookingDetails';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { WEEK_DAYS_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/date';
import { currentAcademicYearRange } from 'Src/helpers/club/clubSectionCounts';

const DEFAULT_SEARCH = {
  order: 'isActionPerformedSetAt:DESC'
};

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  mode?: 'current' | 'previous';
  onSectionCountsChange?: () => void;
  setNeedUpdate?: () => void;
}

const previousAcademicYearsRange = () => {
  const current = currentAcademicYearRange();
  const boundary = new Date(`${current.from}T00:00:00Z`);
  boundary.setUTCDate(boundary.getUTCDate() - 1);
  return { to: boundary.toISOString().slice(0, 10) };
};

interface State {
  items: EventInvitationMessage[];
  selectedItem: EventInvitationMessage | undefined;
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  basePath: string;
  isViewMapModalOpen: boolean;
  isShowDetailsModalOpen: boolean;
}

const ALL_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

const FILTER_FIELDS_STUDENT: ColumnDefinition[] = [
  { text: 'Club name', field: 'clubName', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Sport', field: 'sport', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Invitation date', field: 'createdAt', type: FILTER_TYPE.DATE_INTERVAL, accessor: [''], isSort: true },
  { text: 'Days', field: 'days', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false },
  { text: 'Status', field: 'invitationStatus', type: FILTER_TYPE.TEXT, accessor: [''], isSort: true }
];

export class ClubBookingArchive extends Component<Props, State> {
  private loadRequestId = 0;

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItem: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      basePath: '',
      isViewMapModalOpen: false,
      isShowDetailsModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search || nextProps.mode !== this.props.mode) {
      this.setState({ isLoading: true });
      this.setItems(nextProps);
    }
  }

  private normalizeFiltersForQuery = (f: any) => {
    const src = { ...(f || {}) };
    const out: any = {};

    const trimOrUndef = (v?: any) => {
      if (typeof v === 'string') {
        const s = v.trim();
        return s || undefined;
      }
      if (v && typeof v === 'object') {
        const like = String((v as any).like ?? (v as any).$regex ?? '').trim();
        return like || undefined;
      }
      return undefined;
    };

    const toIso = (s?: string) => {
      if (!s) return s;
      const m1 = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m1) return `${m1[3]}-${m1[2]}-${m1[1]}`;
      if (m2) return s;
      return s;
    };

    const clubName = trimOrUndef(src.clubName);
    const sport = trimOrUndef(src.sport);
    if (clubName) out.clubName = clubName;
    if (sport) out.sport = sport;

    if (typeof src.createdAt === 'string') {
      out.createdAt = { from: toIso(src.createdAt), to: undefined };
    } else if (src.createdAt && (src.createdAt.from || src.createdAt.to)) {
      out.createdAt = { from: toIso(src.createdAt.from), to: toIso(src.createdAt.to) };
    }

    if (Array.isArray(src.days)) {
      const norm = src.days
        .map((d: string) =>
          String(d)
            .trim()
            .toUpperCase()
        )
        .filter(Boolean);
      if (norm.length) out.days = norm;
    } else if (typeof src.days === 'string') {
      const v = String(src.days)
        .trim()
        .toUpperCase();
      if (v) out.days = [v];
    }

    if (typeof src.invitationStatus === 'string' && src.invitationStatus.trim()) {
      out.invitationStatus = src.invitationStatus.trim().toUpperCase();
    }

    return out;
  };

  private setItems(props: Props = this.props) {
    const requestId = ++this.loadRequestId;
    const { user, location } = props;
    const search = parse(location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '' as TABLE_SORT_DIRECTION;
    let sortFieldName = '';
    if (typeof search.order === 'string') {
      const [field, dir] = (search.order as string).split(':');
      sortFieldName = field || '';
      sortDirection = (dir as TABLE_SORT_DIRECTION) || ('' as TABLE_SORT_DIRECTION);
    } else if (typeof DEFAULT_SEARCH.order === 'string') {
      const [field, dir] = DEFAULT_SEARCH.order.split(':');
      sortFieldName = field || '';
      sortDirection = (dir as TABLE_SORT_DIRECTION) || ('' as TABLE_SORT_DIRECTION);
    }

    const sortByFieldExist = !!sortFieldName;
    const sortDirectionExist = !!sortDirection;

    const rawFilters = getFilters2(FILTER_FIELDS_STUDENT, search);

    const likeFromUrl = (key: string): string | undefined => {
      const blob = propz.get(search, ['filter']);
      if (!blob) return undefined;
      try {
        const parsed = JSON.parse(decodeURIComponent(String(blob)));
        const v = parsed?.where?.[key];
        if (!v) return undefined;
        if (typeof v === 'string') return v.trim() || undefined;
        if (typeof v === 'object') return String(v.like ?? v.$regex ?? '').trim() || undefined;
        return undefined;
      } catch {
        return undefined;
      }
    };

    const daysFromUrl = propz.get(search, ['filter'])
      ? (() => {
          try {
            const parsed = JSON.parse(decodeURIComponent(String(search.filter)));
            return Array.isArray(parsed.where?.days) ? parsed.where.days : undefined;
          } catch {
            return undefined;
          }
        })()
      : undefined;

    const clubNameFromUrl = likeFromUrl('clubName');
    const sportFromUrl = likeFromUrl('sport');

    const uiFiltersBase = {
      ...rawFilters,
      ...(daysFromUrl ? { days: daysFromUrl } : {}),
      ...(clubNameFromUrl ? { clubName: clubNameFromUrl } : {}),
      ...(sportFromUrl ? { sport: sportFromUrl } : {})
    };
    const hasAppliedArchiveFilters = Object.keys(search).some(key => key !== 'page' && key !== 'order');
    if (!uiFiltersBase.createdAt && props.mode !== 'previous') {
      uiFiltersBase.createdAt = currentAcademicYearRange();
    }

    if (props.mode === 'previous' && !hasAppliedArchiveFilters) {
      this.setState({
        items: [],
        currentPage: FIRST_PAGE,
        filters: uiFiltersBase,
        sortDirection,
        sortFieldName,
        total: 0,
        basePath: location.pathname,
        isLoading: false
      });
      return BPromise.resolve();
    }

    const filtersForQuery = this.normalizeFiltersForQuery(uiFiltersBase);
    const { createdAt, invitationStatus, ...rest } = filtersForQuery;
    const academic = currentAcademicYearRange();
    const boundedCreatedAt =
      props.mode === 'previous'
        ? {
            ...(createdAt || {}),
            to: createdAt?.to && createdAt.to < academic.from ? createdAt.to : previousAcademicYearsRange().to
          }
        : {
            ...(createdAt || {}),
            from: createdAt?.from && createdAt.from > academic.from ? createdAt.from : academic.from,
            to: createdAt?.to && createdAt.to < academic.to ? createdAt.to : academic.to
          };

    const where = {
      kind: 'ClubParticipantInviteMessage',
      ...rest,
      createdAt: boundedCreatedAt,
      ...(invitationStatus ? { invitationStatus } : {})
    };

    const order = sortByFieldExist && sortDirectionExist ? `${sortFieldName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);

    const getItemsPromise = getStudentArchiveMessages(user, serverQueryFilter);
    const getItemsCountPromise = getStudentArchiveMessagesCount(user, where);

    return BPromise.all([getItemsPromise, getItemsCountPromise]).then(([clubBookings, clubBookingsCountObj]) => {
      if (requestId !== this.loadRequestId) return;
      this.setState({
        items: clubBookings,
        currentPage: page,
        filters: uiFiltersBase,
        sortDirection,
        sortFieldName,
        total: clubBookingsCountObj.count,
        basePath: location.pathname,
        isLoading: false
      });
    });
  }

  private setCurrentPageParams = (currentPage: number): void => {
    const { filters, sortFieldName, sortDirection, basePath } = this.state;
    const parts: string[] = [];

    if (currentPage !== 1) parts.push(`page=${currentPage}`);
    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: basePath, search: parts.join('&') });
  };

  private onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, from: filterValue } };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, to: filterValue } };
          break;
      }
    } else if (filterField === 'invitationStatus') {
      if (filterValue) nextFilters = { ...nextFilters, invitationStatus: filterValue };
      else {
        nextFilters = { ...nextFilters };
        delete nextFilters.invitationStatus;
      }
    } else {
      const def = FILTER_FIELDS_STUDENT.find(col => col.field === filterField);
      if (def?.type === FILTER_TYPE.MULTISELECT) {
        const optionsEl = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < optionsEl.length; i++) {
          if (optionsEl[i].selected) value.push(optionsEl[i].value);
        }
        nextFilters = { ...nextFilters, [filterField]: value };
      } else {
        nextFilters = { ...nextFilters, [filterField]: filterValue };
      }
    }

    this.setState({ filters: nextFilters });
  };

  private toggleDay = (day: string) => {
    const d = day.toUpperCase();

    this.setState(prev => {
      const cur: string[] = Array.isArray(prev.filters.days) ? prev.filters.days : [];
      const exists = cur.includes(d);
      const next = exists ? cur.filter(x => x !== d) : [...cur, d];

      const nextFilters = { ...prev.filters };
      if (next.length) nextFilters.days = next;
      else delete nextFilters.days;

      return { filters: nextFilters };
    });
  };

  private onApplyFilterClick = (): void => {
    const { sortDirection, sortFieldName, basePath } = this.state;
    const parts: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: basePath, search: parts.join('&') });
  };

  private onClearFilterClick = (): void => {
    this.props.history.push({ pathname: this.state.basePath, search: '' });
  };

  private renderViewMapModal = () => {
    const { isViewMapModalOpen, selectedItem } = this.state;
    const point = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'point']);

    return (
      <SimpleModal
        isOpen={isViewMapModalOpen}
        onCloseClick={this.closeViewMapModal}
        title="View map"
        customClass="parentCompactModal"
      >
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };

  private openViewMapModal = message => this.setState({ isViewMapModalOpen: true, selectedItem: message });
  private closeViewMapModal = () => this.setState({ isViewMapModalOpen: false, selectedItem: undefined });

  private renderShowDetailsModal = () => {
    const { isShowDetailsModalOpen, selectedItem } = this.state;
    return (
      <SimpleModal
        isOpen={isShowDetailsModalOpen}
        onCloseClick={this.closeShowDetailsModal}
        title="Club details"
        side="right"
        showFooter={false}
      >
        <ClubBookingDeatils message={selectedItem} />
      </SimpleModal>
    );
  };
  private openShowDetailsModal = message => this.setState({ isShowDetailsModalOpen: true, selectedItem: message });
  private closeShowDetailsModal = () => this.setState({ isShowDetailsModalOpen: false, selectedItem: undefined });

  private onReturnToInboxClick = message => {
    const { user } = this.props;
    this.setState({ isLoading: true });
    cancelRejectionOfStudentClubInvitation(user, message.id)
      .then(() => this.setItems())
      .then(() => {
        if (this.props.setNeedUpdate) this.props.setNeedUpdate();
        if (this.props.onSectionCountsChange) this.props.onSectionCountsChange();
      });
  };

  render() {
    const { user } = this.props;
    const { isLoading, isFiltersOpen, total, currentPage, items, filters } = this.state;
    const archiveSearch = parse(this.props.location.search);
    const hasAppliedArchiveFilters = Object.keys(archiveSearch).some(key => key !== 'page' && key !== 'order');

    if (isLoading) return <Loader />;

    const selectedDays: string[] = Array.isArray(filters.days) ? filters.days : [];

    const needsDateHint =
      !!(filters?.sport && String(filters.sport).trim()) &&
      !(propz.get(filters, ['createdAt', 'from']) || propz.get(filters, ['createdAt', 'to']));

    return (
      <div className="studentClubInvitesContent">
        {this.renderShowDetailsModal()}
        {this.renderViewMapModal()}

        {this.props.mode !== 'previous' ? (
          <div className="parentHistoryNotice">
            <strong>Showing this academic year</strong>
          </div>
        ) : null}

        <div className="studentHubControls">
          <div className="parentListSearch">
            <input
              type="search"
              className="form-control"
              placeholder="Search club name…"
              aria-label="Search by club name"
              value={filters.clubName || ''}
              onChange={e => this.onTableFilterChange(e, 'clubName')}
              onKeyDown={e => {
                if (e.key === 'Enter') this.onApplyFilterClick();
              }}
            />
          </div>
          <button
            className={isFiltersOpen ? 'parentFilterButton is-active' : 'parentFilterButton'}
            onClick={() => this.setState(prev => ({ isFiltersOpen: !prev.isFiltersOpen }))}
          >
            <span className="parentFilterButton__icon" aria-hidden="true" /> Filters
          </button>

          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div>

        <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'clubName', label: 'Club name' },
            { filterKey: 'sport', label: 'Sport' },
            { filterKey: 'createdAt', label: 'Invitation date', type: 'date' },
            {
              filterKey: 'invitationStatus', label: 'Status',
              valueLabels: { ACCEPTED: 'Accepted', REJECTED: 'Declined' }
            },
            {
              filterKey: 'days', label: 'Days', type: 'multi',
              valueLabels: {
                MONDAY: 'Monday', TUESDAY: 'Tuesday', WEDNESDAY: 'Wednesday', THURSDAY: 'Thursday',
                FRIDAY: 'Friday', SATURDAY: 'Saturday', SUNDAY: 'Sunday'
              }
            }
          ]}
        />

        {isFiltersOpen && (
          <ParentFilterBar
            filters={filters}
            showTextFilter={false}
            onTableFilterChange={this.onTableFilterChange}
            onApply={this.onApplyFilterClick}
            onClear={this.onClearFilterClick}
            onCancel={() => this.setState({ isFiltersOpen: false })}
            hint={
              needsDateHint ? (
                <>Choose an invitation date as well as an activity or sport to search the archive.</>
              ) : (
                undefined
              )
            }
            labels={{
              text: 'Club name',
              secondText: 'Activity/Sport',
              date: 'Invitation date',
              status: 'Invitation status'
            }}
            fieldKeys={{
              textKey: 'clubName',
              secondTextKey: 'sport',
              dateKey: 'createdAt',
              statusKey: 'invitationStatus'
            }}
            showStatus
            statusOptions={[
              { value: '', label: 'All' },
              { value: 'ACCEPTED', label: 'Accepted' },
              { value: 'REJECTED', label: 'Declined' },
              { value: 'OUTDATED', label: 'Outdated' }
            ]}
            extraFilters={
              <div className="parentFilterDrawer__field">
                <label className="form-label">Days of week</label>
                <div className="studentHubFilterChips">
                  {ALL_DAYS.map(d => {
                    const active = selectedDays.includes(d);
                    return (
                      <button
                        key={d}
                        type="button"
                        className={active ? 'studentHubFilterChip is-active' : 'studentHubFilterChip'}
                        onClick={() => this.toggleDay(d)}
                      >
                        {WEEK_DAYS_SERVER_TO_CLIENT_MAPPING[d] || d.charAt(0) + d.slice(1).toLowerCase()}
                      </button>
                    );
                  })}
                  {selectedDays.length > 0 && (
                    <button
                      type="button"
                      className="studentHubFilterChip"
                      onClick={() => {
                        this.setState(prev => {
                          const next = { ...prev.filters };
                          delete next.days;
                          return { filters: next };
                        });
                      }}
                    >
                      Clear days
                    </button>
                  )}
                </div>
              </div>
            }
          />
        )}

        {items.length === 0 ? (
          <div className="studentHubEmpty">
            <span className="studentHubEmpty__icon">C</span>
            <strong>
              {this.props.mode === 'previous' && !hasAppliedArchiveFilters
                ? 'Search previous academic years'
                : this.props.mode === 'previous'
                ? 'No club invitations match your filters'
                : 'No club invitations from this academic year'}
            </strong>
            <p>
              {this.props.mode === 'previous' && !hasAppliedArchiveFilters
                ? 'Use the filters to find older club invitations without loading your full history.'
                : this.props.mode === 'previous'
                ? 'Try changing or removing one of the filters.'
                : 'Previous invitations from this academic year will appear here.'}
            </p>
          </div>
        ) : (
          <div className="row gap-3 mt-2">
            {items.map(item => {
              const { id } = item;
              return (
                <div className="col-12 col-sm-6 col-lg-4 mb-4" key={id}>
                  <ClubBookingCard
                    user={user}
                    item={item}
                    type={INVITE_TYPE.ARCHIVE}
                    onViewMapClick={this.openViewMapModal}
                    onShowDetailsClick={this.openShowDetailsModal}
                    onReturnToInboxClick={this.onReturnToInboxClick}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
